/* __next_internal_client_entry_do_not_use__ AddUser auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4156%3A461))
 * @trackcomponent
 * @lastsynced 2023-09-21T14:42:39.622Z
 */ export var AddUser = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M8.71408 9.53582C9.25343 9.53582 9.78751 9.42958 10.2858 9.22318C10.7841 9.01678 11.2369 8.71425 11.6183 8.33286C11.9996 7.95148 12.3022 7.49871 12.5086 7.00041C12.715 6.50211 12.8212 5.96803 12.8212 5.42868C12.8212 4.88932 12.715 4.35524 12.5086 3.85694C12.3022 3.35864 11.9996 2.90587 11.6183 2.52449C11.2369 2.1431 10.7841 1.84057 10.2858 1.63417C9.78751 1.42777 9.25343 1.32153 8.71408 1.32153C7.62479 1.32153 6.58013 1.75425 5.80989 2.52449C5.03965 3.29473 4.60693 4.33939 4.60693 5.42868C4.60693 6.51796 5.03965 7.56263 5.80989 8.33286C6.58013 9.1031 7.62479 9.53582 8.71408 9.53582Z",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M11.1784 21.0358H1.32129V20.1454C1.33437 18.8932 1.66461 17.6647 2.28117 16.5748C2.89772 15.4848 3.78048 14.5689 4.84698 13.9126C5.91348 13.2563 7.12893 12.881 8.3798 12.8218C9.63066 12.7625 10.8761 13.0213 11.9999 13.574",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M18.1606 13.6431V22.6788",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M13.6426 18.1609H22.6783",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
}), "AddUser", {
    color: Core.icon.default,
    fill: "none",
    viewBox: "0 0 24 24"
} // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
